export const BICYCLE_MODELS = [
  { label: 'City 1', value: 'City 1' },
  { label: 'City 7', value: 'City 7' },
  { label: 'City 8', value: 'City 8' },
  { label: 'Cross 1', value: 'Cross 1' },
  { label: 'Cross 7', value: 'Cross 7' },
  { label: 'Metro Retro 1', value: 'Metro Retro 1' },
  { label: 'Metro Retro 7', value: 'Metro Retro 7' },
]
